<template>
  <div class="d-flex align-center">
    <span data-testid="jira-issue-links-title" class="w-20 font-weight-bold"
      >Issue Links</span
    >
    <div class="d-flex flex-column gap-2 w-80">
      <v-card v-for="issue in issueLinks" :key="issue.id" class="w-100">
        <v-card-text
          data-testid="jira-issue-links-card"
          class="d-flex align-center gap-3"
        >
          <SoLink
            data-testid="jira-issue-links-link"
            :text="getIssueText(issue)"
            :href="getIssueLink(issue)"
          />
          <SoBadge
            data-testid="jira-issue-links-badge"
            :color="getIssueContent(issue)?.status.type"
          >
            {{ getIssueContent(issue)?.status.text }}
          </SoBadge>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoLink from "@/components/SoLink.vue"
  import { IssueLink } from "@/models/jiraIssue/jiraIssue.types"
  import SoBadge from "@/components/SoBadge.vue"

  export default defineComponent({
    components: { SoBadge, SoLink },
    props: {
      issueLinks: {
        type: Array as PropType<IssueLink[]>,
        default: [] as IssueLink[],
        required: true,
      },
    },
    methods: {
      getIssueText(issue: IssueLink) {
        if (issue.inwardIssue) {
          return `${issue.inwardIssue.key} - ${issue.inwardIssue.fields.summary}`
        } else if (issue.outwardIssue) {
          return `${issue.outwardIssue.key} - ${issue.outwardIssue.fields.summary}`
        }
      },
      getIssueLink(issue: IssueLink) {
        if (issue.inwardIssue) {
          return `/issues/${issue.inwardIssue.key}`
        } else if (issue.outwardIssue) {
          return `/issues/${issue.outwardIssue.key}`
        }
      },
      getIssueContent(issue: IssueLink) {
        if (issue.inwardIssue) {
          return issue.inwardIssue
        } else if (issue.outwardIssue) {
          return issue.outwardIssue
        }
      },
    },
  })
</script>

<style scoped>
  .w-20 {
    min-width: 20%;
  }

  .w-80 {
    width: 80%;
  }
</style>
